export default __webpack_public_path__ + "static/media/link.d6eed537.png";